import 'shows/truncateToHeight';

$.fn.ellipsify = function () {
    let wrapper = $(this);
    let titleWrappers = wrapper.find('.title-wrapper');

    if (
        titleWrappers.length > 0 &&
        typeof titleWrappers.get(0).style.webkitLineClamp != 'undefined'
    ) {
        return;
    }

    titleWrappers.each((idx, el) => {
        let wrapperId = $(el).attr('id');
        if (wrapperId === undefined) {
            wrapperId = 'title-wrapper-' + Math.floor(Math.random() * 1000000);
            $(el).attr('id', wrapperId);
        }

        let titleEl = $(el).find('.title');
        let titleId = titleEl.attr('id');
        if (titleId === undefined) {
            titleId = 'title-' + Math.floor(Math.random() * 1000000);
            titleEl.attr('id', titleId);
        }

        let oTruncate = {
            heightElementId: wrapperId,
            contentElementId: titleId,
        };

        TruncateToHeight.truncate(oTruncate);
    });
};
